import {ActivatedRouteSnapshot, Resolve} from '@angular/router';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {RouteHelperService} from '../services/route-helper.service';
import {SessionService} from '../services/session.service';
import {PagedCaseOverviewHal} from '../models/HAL/caseOverview-hal.model';
import {
  buildCasesUrl,
  CASES_OVERVIEW_STATE_FILTER_OPTIONS,
  loadPreferences,
  removePreferences
} from '../pages/cases-overview/cases-overview-preferences';

@Injectable({
  providedIn: 'root'
})
export class CasesOverviewResolver implements Resolve<PagedCaseOverviewHal> {

  constructor(
    private readonly routeHelperService: RouteHelperService,
    private readonly httpClient: HttpClient,
    private readonly sessionService: SessionService
  ) {
  }

  resolve(route: ActivatedRouteSnapshot) {
    const baseUrl = this.routeHelperService.getApiUrlBasedOnActivatedRouteSnapshot(route);
    const preferences = loadPreferences();

    if (!preferences) {
      removePreferences();
      const url = buildCasesUrl({
        baseUrl,
        page: 0,
        size: 20,
        sortActive: null,
        sortDirection: null,
        searchTerm: null,
        userFilter: null,
        stateFilters: null
      });
      return this.httpClient.get<PagedCaseOverviewHal>(url.href);
    }

    const validStates = preferences.stateFilters
      ? preferences.stateFilters.filter(state => CASES_OVERVIEW_STATE_FILTER_OPTIONS.includes(state))
      : null;

    const userId = this.sessionService.getSession()?.user?.identification;

    const url = buildCasesUrl({
      baseUrl,
      page: 0,
      size: 20,
      sortActive: preferences.sortActive,
      sortDirection: preferences.sortDirection,
      searchTerm: preferences.searchTerm,
      userFilter: userId && preferences.onlyShowMyCases ? userId : null,
      stateFilters: validStates
    });

    return this.httpClient.get<PagedCaseOverviewHal>(url.href);
  }
}

